module.exports = __webpack_public_path__ + "static/media/find_in_the_picture1_active.de4e5cf3.png";